/**
 * analytics.js — Google Tag Manager, only when a container ID is configured.
 *
 * Set VITE_GTM_ID=GTM-XXXXXXX in .env.production (the live site's container is
 * in there). With no ID this is a no-op and dev/preview builds stay
 * tracker-free. The travel app applies the same rule with NEXT_PUBLIC_GTM_ID
 * (travel-journey/app/layout.tsx). Whatever tags run is decided in the GTM
 * container itself; this file only loads it and feeds it events.
 */
export const GTM_ID = (import.meta.env?.VITE_GTM_ID || '').trim();

export function initAnalytics() {
  if (!GTM_ID || typeof window === 'undefined' || window.__gtmReady) return;
  window.__gtmReady = true;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ 'gtm.start': Date.now(), event: 'gtm.js' });
  const s = document.createElement('script');
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtm.js?id=${encodeURIComponent(GTM_ID)}`;
  document.head.appendChild(s);
}

/** A world opening, a channel change: things worth a line in the report. Lands in the dataLayer for GTM to route. */
export function track(event, params = {}) {
  if (!GTM_ID || typeof window === 'undefined') return;
  (window.dataLayer = window.dataLayer || []).push({ event, ...params });
}
